export enum EmojiEnum {
  THUMBS_UP = "👍",
  Grinning_Face_with_Sweat = "😅",
  SAD_RELIEVED = "😥",
  NERD = "🤓",

  UNAMUSED = "😒",
  THINKING = "🤔",
  FACE_SCREAMING_IN_FEAR = "😱",
  FACE_WITH_SYMBOLS_ON_MOUTH = "🤬",

  Smiling_Face_with_Sunglasses = "😎",
  Exploding_Head = "🤯",
  MELTING_FACE = "🫠",
  BLOND_HAIR = "👱‍♀️",

  HEART = "❤️",
  FIRE = "🔥",
  PARTY_POPPER = "🎉",
  WRAPPED_GIFT = "🎁",
}
